import React, { FC, memo } from 'react';
import { styled as muiStyled } from '@material-ui/core/styles';
import { CreateCSSProperties } from '@material-ui/core/styles/withStyles';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import { SvgIconProps, SvgIconTypeMap } from '@material-ui/core';
import { COLORS } from 'components/twilio/constants';

export interface ColoredMaterialIconProps {
  Icon: OverridableComponent<SvgIconTypeMap<any, 'svg'>>;
  color?: string;
  overrides?: CreateCSSProperties;
}

const ColoredMaterialIcon: FC<ColoredMaterialIconProps & Omit<SvgIconProps, 'color'>> = ({
  Icon,
  color = COLORS.ICON,
  overrides = {},
  ...svgProps
}: ColoredMaterialIconProps) => {
  const StyledIcon = muiStyled(Icon)({
    fill: color,
    ...overrides,
  } as CreateCSSProperties);
  return <StyledIcon {...svgProps} />;
};

export default memo(ColoredMaterialIcon);
